export const projects = [
    {
        id: 1,
        title: 'My Wallet',
        url: 'https://github.com/JoaopSilvaa/my-wallet',
        image: require('./images/wallet-vectorportal-removebg-preview.png'),
        gif: require('./gifs/wallet.gif'),
        description: 'Este projeto é uma carteira de controle de gastos com um conversor de moedas, proporcionando ao usuário um ambiente em que pode: Adicionar, remover e editar seus gastos',
        technologies: "React, Redux, HTML, CSS, Javascript",
    },
    {
        id: 2,
        title: 'Shopping Cart',
        url: 'https://github.com/JoaopSilvaa/shooping-cart',
        image: require('./images/shopping-cart-vectorportal-removebg-preview.png'),
        gif: require('./gifs/shopping.gif'),
        description: 'Este projeto é um simulador de carrinho de compras, em que faz requisições a uma API do Mercado livre (manual da API do Mercado Livre), trabalha com funções assíncronas e contém testes unitários',
        technologies: "Testes Unitários, Jest, HTML, CSS, Javascript",
    },
    {
        id: 3,
        title: 'Js Tunes',
        url: 'https://github.com/JoaopSilvaa/js-tunes',
        image: require('./images/headphones-vectorportal-removebg-preview.png'),
        gif: require('./gifs/tunes.gif'),
        description: 'Esta é uma aplicação capaz de reproduzir músicas das mais variadas bandas e artistas, criar uma lista de músicas favoritas e editar o perfil da pessoa usuária logada.',
        technologies: "React, LocalStorage, HTML, CSS, Javascript",
    },
    {
        id: 4,
        title: 'Recipes App',
        url: 'https://github.com/JoaopSilvaa/recipes-app',
        image: require('./images/recipes.jpg'),
        gif: require('./gifs/apprecipes.gif'),
        description: 'Este projeto é um app de receitas, em que a pessoa usuária é capaz de procurar por uma receita específica, explorar receitas baseada em diferentes critérios, favoritar e fazer as receitas entre outras funcionalidades',
        technologies: "React, Redux, API, Jest, HTML, CSS, Javascript",
    },
    {
        id: 5,
        title: 'RPG Simulator',
        url: 'https://github.com/JoaopSilvaa/rpg-simulator',
        image: require('./images/rpg.jpg'),
        gif: require('./images/rpg.jpg'),
        description: `Projeto utilizando arquitetura SOLID e princípios de POO, estruturando um simulador de jogos de interpretação, conhecidos como RPG (Role Playing Game).
        Por esse projeto ser voltado a Backend ele não tem gif de demonstração, acesse o github abaixo para clonar o repositório e utilizar em sua máquina.`,
        technologies: "SOLID, POO, Typescript",
    },
    {
        id: 6,
        title: 'Blogs Api',
        url: 'https://github.com/JoaopSilvaa/blogs-api',
        image: require('./images/posts.jpg'),
        gif: require('./images/posts.jpg'),
        description: 'Projeto que contém uma aplicação Node.js, que utiliza do pacote Sequelize para fazer um CRUD de posts. Construindo uma API e um banco de dados para produção de conteúdo para um blog. Por esse projeto ser voltado a Backend ele não tem gif de demonstração, acesse o github abaixo para clonar o repositório e utilizar em sua máquina.',
        technologies: "Node.js, API Rest, Autenticação JWT, Express, Sequelize, MySQL",
    },
    {
        id: 7,
        title: 'Futebol Clube',
        url: 'https://github.com/JoaopSilvaa/futebol-clube',
        image: require('./images/football-vectorportal-removebg-preview.png'),
        gif: require('./images/football-vectorportal-removebg-preview.png'),
        description: 'É um site informativo sobre partidas e classificações de futebol! Aqui foi construído um back-end dockerizado utilizando modelagem de dados através do Sequelize.',
        technologies: "Node.js, CRUD, Sequelize, MySQL, API Rest, Typescript, Javascript, Docker",
    },
    {
        id: 8,
        title: 'Tech News',
        url: 'https://github.com/JoaopSilvaa/Tech-News',
        image: require('./images/crawler.jpg'),
        gif: require('./images/crawler.jpg'),
        description: 'Crawler capaz de pegar dados de notícias no site da Trybe. Por esse projeto ser voltado a Backend ele não tem gif de demonstração, acesse o github abaixo para clonar o repositório e utilizar em sua máquina.',
        technologies: "Python, MongoDB, Webscraping, Crawler",
    },
    {
        id: 9,
        title: 'Algorithms',
        url: 'https://github.com/JoaopSilvaa/Algorithms',
        image: require('./images/algo-removebg-preview.png'),
        gif: require('./images/algo-removebg-preview.png'),
        description: 'Resoluções de problemas e otimização de algoritmos. Por esse projeto ser voltado a Backend ele não tem gif de demonstração, acesse o github abaixo para clonar o repositório e utilizar em sua máquina.',
        technologies: "Python, Algorithms",
    },
]